import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import moment from 'moment'
import { WTPSecurityDeleteAPI, WTPSecurityTableDataAPI, WTPSecurityTableDataAPIExport } from '../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/PreventiveData/PreventiveDataSecuritySlice'
import ViewURL from '../../../../../Components/ViewURL/ViewURL'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../Helper/Loading'
import DeletePopup from '../../GardenPopup/DeletePopup'
import { WTPPreventiveSecurityPageExport } from './WTPPreventiveSecurityPageExport'

export default function WTPPreventiveSecurityPage() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails

    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let ScreenName = searchParams.get("ScreenName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")


    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [ShowImagePopup, setshowImagePopup] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [Heading, setHeading] = useState('')


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    // const date = Month?.ID != 0 && moment().month(Month?.ID - 1).format('YYYY-MM-DD');
    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))

        // console.log("call")
    }

    const handleShowImage = (Imageurl, heading) => {
        setshowImagePopup(true)
        setImagePopUpData(Imageurl)
        setHeading(heading)
    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_WTP_PumpingStationID: '0',
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            Flag: ScreenName
        }
        if (WardName.ID !== 0) {
            dispatch(WTPSecurityTableDataAPI({ data }))
        }

    }, [IsPost, To, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.WTPSecurityTableData)

    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_WTP_PumpingStationID: '0',
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '9999',
            Flag: ScreenName
        }
        if (WardName.ID !== 0) {
            dispatch(WTPSecurityTableDataAPIExport({ data }))
        }

    }, [IsPost, To, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.WTPSecurityTableDataExportData)

    const handleDeleteApi = (item) => {
        const data = {
            T_WTP_SecurityID: item.t_wtP_SecurityID,
            T_WTP_HouseKeepingID: item.t_wtP_HouseKeepingID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            Flag: (ScreenName && ScreenName == "House Keeping") ? "HouseKeeping" :''
        }
        dispatch(WTPSecurityDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WTPSecurityDeleteData)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId}
                />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>{ScreenName}</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            ExportTableData && ExportTableData.table && ExportTableData.table.length > 0 &&
                                            <WTPPreventiveSecurityPageExport
                                                ExcelData={ExportTableData}
                                                name={ScreenName ? ScreenName : 'Security'}
                                                FromDate={FromDate}
                                                ToDate={ToDate}
                                                WardName={WardName.Label}
                                            // searchName={searchName}
                                            />
                                    }

                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">
                                        <div className="row py-1 rounded2">
                                            <div className="col-12 col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={FromDate}
                                                        onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={ToDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                        min={FromDate}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-3">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Reading Date</th>
                                                        <th>Pumping Station</th>
                                                        <th>Status</th>
                                                        <th>Photo</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                <td>{item.pumpingStation ? item.pumpingStation : '-'}</td>
                                                                <td>{item.indicatorName ? item.indicatorName : '-'}</td>
                                                                {/* <td>{item.ph ? item.ph.toFixed(2) : '-'}</td> */}
                                                                <td style={{ textAlign: "center" }}>
                                                                    {
                                                                        (item.photo == null) ?
                                                                            <span>-</span>
                                                                            :
                                                                            <>
                                                                                <i className="fa-solid fa-eye" title='View'
                                                                                    style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                    onClick={() => handleShowImage(item.photo, 'Photo')}
                                                                                ></i>
                                                                            </>
                                                                    }
                                                                </td>
                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    {
                                                                        (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                            <>
                                                                                <span>
                                                                                    <DeletePopup
                                                                                        open={DeletePopupShow}
                                                                                        handleDeleteApi={handleDeleteApi}
                                                                                        item={item}
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* {
                    WTPQuantityOfWaterPagePopupShow ?
                        <WTPQuantityOfWaterPagePopup
                            open={WTPQuantityOfWaterPagePopupShow}
                            // handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                        // Flag={apiFlag}
                        // rowData={rowData}
                        />
                        : <></>
                } */}


            </div>
            {
                ShowImagePopup &&
                <ViewURL
                    Heading={Heading}
                    ImagePopUpData={ImagePopUpData}
                    setshowImagePopup={setshowImagePopup}
                />
            }
        </div>



    )
}